import { render, staticRenderFns } from "./MyQuillEditor.vue?vue&type=template&id=8d53d026&"
import script from "./MyQuillEditor.vue?vue&type=script&lang=js&"
export * from "./MyQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./MyQuillEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports